import {
  require_jquery
} from "./chunk-W467FMWY.js";
import "./chunk-AC2VUBZ6.js";
export default require_jquery();
//# sourceMappingURL=jquery.js.map
